import { request } from '../utils';
import { FORGOT_USERNAME_API, LOGIN_API, LOGOUT_API, SAML_LOGIN_API, RESET_PASSWORD_API, MFA_AUTH, MFA_QR_CODE, MFA_OTP_CODE, MFA_AUTH_APP, MFS_CREATE, MFA_DETAILS, MFA_AUTH_OTP, MFA_DELETE, MFA_SKIP, MFA_RESEND_OTP, API_PROVIDER_SERVICE_NETWORK } from '../routes/api';

class appApi {
  static login(options, onSuccess, onError) {
    return request({ url: LOGIN_API, method: 'post', ...options }, onSuccess, onError);
  }

  static logout(options, onSuccess, onError) {
    return request({ url: LOGOUT_API, method: 'delete', ...options }, onSuccess, onError);
  }

  static samlLogin(options, onSuccess, onError) {
    return request({ url: SAML_LOGIN_API, method: 'post', ...options }, onSuccess, onError);
  }

  static forgot(options, onSuccess, onError) {
    return request({ url: FORGOT_USERNAME_API, method: 'post', ...options }, onSuccess, onError);
  }

  static reset(options, onSuccess, onError) {
    return request({ url: RESET_PASSWORD_API, method: 'post', ...options }, onSuccess, onError);
  }

  // MFA API
  static mfaDetail(options, onSuccess, onError) {
    return request({ url: MFA_DETAILS, method: 'get', ...options }, onSuccess, onError);
  }

  static mfaDelete(options, onSuccess, onError) {
    return request({ url: MFA_DELETE, method: 'delete', ...options }, onSuccess, onError);
  }

  static mfaSkip(options, onSuccess, onError) {
    return request({ url: MFA_SKIP, method: 'post', ...options }, onSuccess, onError);
  }

  static mfaAuth(options, onSuccess, onError) {
    return request({ url: MFA_AUTH, method: 'post', ...options }, onSuccess, onError);
  }

  static mfaQRAuth(options, onSuccess, onError) {
    return request({ url: MFA_AUTH_APP, method: 'get', ...options }, onSuccess, onError);
  }

  static mfaOTPAuth(options, onSuccess, onError) {
    return request({ url: MFA_AUTH_OTP, method: 'get', ...options }, onSuccess, onError);
  }

  static mfaQRCode(options, onSuccess, onError) {
    return request({ url: MFA_QR_CODE, method: 'post', ...options }, onSuccess, onError);
  }

  static mfaOTPCode(options, onSuccess, onError) {
    return request({ url: MFA_OTP_CODE, method: 'post', ...options }, onSuccess, onError);
  }

  static mfaResendOTP(options, onSuccess, onError) {
    return request({ url: MFA_RESEND_OTP, method: 'post', ...options }, onSuccess, onError);
  }

  static mfaCreate(options, onSuccess, onError) {
    return request({ url: MFS_CREATE, method: 'post', ...options }, onSuccess, onError);
  }

  static providerServiceNetwork(options, onSuccess, onError) {
    return request({ url: options.url, method: 'get', ...options}, onSuccess, onError)
  }
}

export default appApi;